import styles from 'styles/modules/EditContent.module.scss';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';

const EditContent = (props) => {
    const { isAuthorized } = useSelector(authSelector);

    if (!isAuthorized) {
        return null;
    }
    let data = {
        style: 'noLabel',
        label: 'Edit',
        onClick: () => {},
    };

    if (props.data) data = { ...data, ...props.data };

    return (
        <div
            className={[styles.wrapper, styles[data.style]].join(' ')}
            onClick={data.onClick}
        >
            <div className={styles.icon} />
            <div className={styles.label}>{data.label}</div>
        </div>
    );
};

export default EditContent;
